import React, {useState,useEffect} from 'react';
import { XText } from './XText';
import {useNodes} from './NodeContext'
import {Spinner} from "../Spinner/Spinner"

export interface MyComponentProps {
  itemExpressionid: string
  focusExpressionId: string
}

export const XTextStart: React.FC<MyComponentProps> = (props) => {
  const [page, setPage] = useState<number>(1);
  const [pageLength, setPageLength] = useState<number>(40);
  const startParagraph = pageLength * (page - 1) + 1;
  const endParagraph = pageLength * page;
  const { data, handleChangeInfo } = useNodes();
  const paraNodes = data?.paraNodes || {}
  const pToDNodesMap = data?.pToDNodesMap || {}
  const dnodes = data?.dnodes || {}
  const elementToPNodesMap = data?.elementToPNodesMap || {}
  const paraCount = Object.keys(paraNodes).length

  useEffect(() => {
    setPage(1)
  }, [props.itemExpressionid])

  
  useEffect(() => {
    // compute the page based on p number of focused resource
    // note for Div, first a check on paraNodes
    // for Element, first a check on paraNodes, then on dnodes
    // if the type was already known we can skip the extra checks
    // but the checks may be very fast, so not really worth they extra copmlexity
    const pNodeNum = paraNodes[props.focusExpressionId?.split("/resource/")[1]]?.count
    if (pNodeNum){
      const newPage = Math.ceil(pNodeNum / pageLength)
      setPage(newPage)
    }
    else if (dnodes[props.focusExpressionId?.split("/resource/")[1]]){
      const pnode = dnodes[props.focusExpressionId?.split("/resource/")[1]].firstPNodeId
      let pNodeNum = paraNodes[pnode]?.count
      const newPage = Math.ceil(pNodeNum / pageLength)
      setPage(newPage)
    }
    else if (elementToPNodesMap[props.focusExpressionId?.split("/resource/")[1]]){
      const pnode = elementToPNodesMap[props.focusExpressionId?.split("/resource/")[1]][0]
      let pNodeNum = paraNodes[pnode]?.count
      const newPage = Math.ceil(pNodeNum / pageLength)
      setPage(newPage)
    }
    else(
      setPage(1)
    )
  }, [props.focusExpressionId, paraNodes, dnodes, elementToPNodesMap])
  
  
  const handlePrev = () => {
    const newPrevPage: number = page - 1
    setPage(newPrevPage)
    const newFocusPNum = ((newPrevPage - 1) * pageLength) + pageLength
    const newFocusP = Object.entries(paraNodes).find(([key, node]: [string, any]) => node.count === newFocusPNum);
    handleChangeInfo("http://scta.info/resource/" + (newFocusP && newFocusP[0]))
  }
  const handleNext = () => {
    
    const newNextPage: number = page + 1
    const newFocusPNum = ((newNextPage - 1) * pageLength) + 1
    const newFocusP = Object.entries(paraNodes).find(([key, node]: [string, any]) => node.count === newFocusPNum);
    setPage(newNextPage)
    handleChangeInfo("http://scta.info/resource/" + (newFocusP && newFocusP[0]))
  }

  return (
    <>
      {startParagraph > 1 ? <button onClick={() => handlePrev()}>Prev</button> : null}
      {data?.data[0] ? <XText nodes={data?.data[0]} startParagraph={startParagraph} endParagraph={endParagraph} /> : <Spinner/>}
      {paraCount > endParagraph ? <button onClick={() => handleNext()}>Next</button> : null}
    </>
  )
}
  